<template>
  <div>
    {{ cash }} GIC
  </div>
</template>

<script>
export default {
  name: 'c-user-balance',
  props: ['cash'],
};
</script>
